import { Suspense } from 'react'
import { ParentPortalDashboard } from '@features/dashboards/parent-portal/ParentPortalDashboard'
import { StaffPortalDashboard } from '@features/dashboards/staff-portal/StaffPortalDashboard'
import { StudentPortalDashboard } from '@features/dashboards/student-portal/StudentPortalDashboard'
import { usePortalModeStore } from '@stores/usePortalModeStore'
import { createFileRoute } from '@tanstack/react-router'
import { LoadingIndicator } from '@ui/LoadingIndicator'

export const Route = createFileRoute('/_layout/home')({
    staticData: {
        title: 'Home',
    },
    component: () => 
        <Suspense fallback={<LoadingIndicator resource="dashboard" />}>
            {usePortalModeStore.getState().viewMode === 'staff' ? 
            <StaffPortalDashboard />
            :
            usePortalModeStore.getState().viewMode === 'student' ? 
            <StudentPortalDashboard /> 
            : 
            <ParentPortalDashboard />}
        </Suspense>,
})
